(ns manatee.admin.queue.app-db
  "App. DB support for the admin. queue tab."
  (:require [manatee.admin.app-db :as admin-app-db]))

(def ^:private queue-path
  "The root key for admin. queue tab values."
  (conj admin-app-db/root-path :queue))
(def ^:private queue-configs-path (conj queue-path :configs))
(def ^:private selected-queue-config-id-path (conj queue-path :selected-config-id))
(def ^:private list-view?-path (conj queue-path :list-view?))

(defn get-selected-queue-config-id
  [db]
  (get-in db selected-queue-config-id-path))

(defn set-selected-queue-config-id
  [db id]
  (assoc-in db selected-queue-config-id-path id))

(defn list-view?
  [db]
  (get-in db list-view?-path true))

(defn set-list-view
  [db flag]
  (assoc-in db list-view?-path flag))

(defn get-queue-configs
  [db]
  (get-in db queue-configs-path))

(defn set-queue-configs
  [db configs]
  (assoc-in db queue-configs-path configs))
